import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { API_GET_COMPANYBYID } from "../../api/company.service";
import { WabaHealth } from "./wabaHealth";
import "./company.css";

const formatLabel = (value) =>
  String(value || "")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (match) => match.toUpperCase());

const formatValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

export const BusinessInfo = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState({});

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const companyData = await API_GET_COMPANYBYID(companyId);
        setCompany(companyData || {});
      } catch (error) {
        console.error("Failed to fetch company data:", error);
      }
    };

    if (companyId) {
      fetchCompanyData();
    }
  }, [companyId]);

  const highlights = useMemo(
    () => [
      { label: "Name", value: company?.companyName || "-" },
      { label: "Phone", value: company?.phone || "-" },
      { label: "App Name", value: company?.gupshupAppName || "-" },
      { label: "Billing Address", value: company?.billingAddress || "-" },
    ],
    [company]
  );

  return (
    <div className="company-tab-panel">
      <div className="surface-panel">
        <div className="surface-panel-header">
          <div>
            <h2 className="surface-panel-title">WABA health overview</h2>
          </div>
        </div>
        <div className="company-insight-grid">
          <WabaHealth />
        </div>
      </div>

      <div className="surface-panel">
        <div className="surface-panel-header">
          <div>
            <h2 className="surface-panel-title">Key identifiers</h2>
          </div>
        </div>
        <div className="company-insight-grid">
          {highlights.map((item) => (
            <div className="company-insight-card" key={item.label}>
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      </div>

      <div className="surface-panel">
        <div className="surface-panel-header">
          <div>
            <h2 className="surface-panel-title">Company data registry</h2>
          </div>
        </div>
        <div className="company-data-grid">
          {Object.entries(company || {}).map(([key, value]) => (
            <div className="company-data-card" key={key}>
              <label>{formatLabel(key)}</label>
              <p>{formatValue(value)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
